"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPES = exports.SIZES = void 0;
var SIZES = {
  SMALL: "small",
  NORMAL: "normal",
  LARGE: "large"
};
exports.SIZES = SIZES;
var TYPES = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SEPARATED: "separated"
};
exports.TYPES = TYPES;